import { SwapGuide } from "components/BeginnerGuide/SwapGuide";
import { LiquidityGuide } from "components/BeginnerGuide/LiquidityGuide";

export function BeginnerGuide() {
  return (
    <>
      <SwapGuide />
      <LiquidityGuide />
    </>
  );
}
